// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import PageHeading from "../../../../components/admin/common/PageHeading";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import { toast } from "react-toastify";
// import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// const EditCaseStudy = () => {
//   const { id } = useParams(); // ✅ get slug from URL
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     name: "",
//     image: null,
//     live_url: "",
//     description: "",
//   });
//   const [imagePreview, setImagePreview] = useState(null);

//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

//   // Fetch case study details by slug
//   useEffect(() => {
//     callAPI("get", `admin/case-studies/${id}`);
//   }, [id]);

//   // When data loads, set form fields
//   useEffect(() => {
//     if (response?.data && statusCode === 200) {
//       const caseStudy = response.data;
//       setFormData({
//         name: caseStudy.name || "",
//         live_url: caseStudy.live_url || "",
//         description: caseStudy.description || "",
//         image: null, // reset, because file input cannot be prefilled
//       });
//       setImagePreview(caseStudy.image || null);
//     }
//   }, [response, statusCode]);

//   // Handle update
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const submitData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== null) {
//         submitData.append(key, formData[key]);
//       }
//     });
//     callAPI("post", `admin/case-studies/${id}?_method=PUT`, submitData); // ✅ Laravel style update with PUT
//   };

//   // After update success
//   useEffect(() => {
//     if (statusCode === 202) {
//       toast.success("Case Study updated successfully!");
//       setTimeout(() => {
//         navigate(uiRoutes.admin.casestudy.list);
//       }, 1000);
//     }
//   }, [response, statusCode, navigate]);

//   // Image preview
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, image: file });
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setImagePreview(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container mt-5">
//           <PageHeading
//             title="Edit Case Study"
//             subTitle="Update case study details"
//           />
//           <div className="container card p-4 shadow-sm mt-3">
//             <form
//               onSubmit={handleSubmit}
//               className="row g-3"
//               encType="multipart/form-data"
//             >
//               <h6 className="">Edit Case Study Form</h6>

//               {/* Name */}
//               <div className="col-md-4">
//                 <label className="form-label">Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({ ...formData, name: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.name}
//                 </span>
//               </div>

//               {/* Live URL */}
//               <div className="col-md-4">
//                 <label className="form-label">Live URL</label>
//                 <input
//                   type="url"
//                   className="form-control"
//                   value={formData.live_url}
//                   onChange={(e) =>
//                     setFormData({ ...formData, live_url: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.live_url}
//                 </span>
//               </div>

//               {/* Image Upload */}
//               <div className="col-md-4">
//                 <label className="form-label">Image Upload</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   className="form-control"
//                   onChange={handleImageChange}
//                 />
//                 {imagePreview && (
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="mt-2"
//                     style={{
//                       width: "100%",
//                       maxHeight: "200px",
//                       objectFit: "contain",
//                     }}
//                   />
//                 )}
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.image}
//                 </span>
//               </div>

//               {/* Description */}
//               <div className="col-md-6">
//                 <label className="form-label">Description</label>
//                 <textarea
//                   className="form-control"
//                   rows="2"
//                   value={formData.description}
//                   onChange={(e) =>
//                     setFormData({ ...formData, description: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.description}
//                 </span>
//               </div>

//               {/* Submit */}
//               <div className="col-4 mt-5 mb-5">
//                 <button type="submit" className="btn btn-primary w-100">
//                   Update
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default EditCaseStudy;


import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// ✨ DraftJS
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const EditCaseStudy = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    image: null,
    live_url: "",
  });

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const [imagePreview, setImagePreview] = useState(null);

  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  // Fetch case study details
  useEffect(() => {
    callAPI("get", `admin/case-studies/${id}`);
  }, [id]);

  // Set form values once data is loaded
  useEffect(() => {
    if (response?.data && statusCode === 200) {
      const { name, live_url, description, image } = response.data;

      setFormData({
        name: name || "",
        live_url: live_url || "",
        image: null, // file input can't be pre-filled
      });

      setImagePreview(image || null);

      // Convert HTML description to DraftJS editor state
      if (description) {
        const contentBlock = htmlToDraft(description);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
          );
          setEditorState(EditorState.createWithContent(contentState));
        }
      }
    }
  }, [response, statusCode]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const htmlDescription = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );

    const submitData = new FormData();
    submitData.append("name", formData.name);
    submitData.append("live_url", formData.live_url);
    submitData.append("description", htmlDescription);
    if (formData.image) {
      submitData.append("image", formData.image);
    }

    callAPI("post", `admin/case-studies/${id}?_method=PUT`, submitData);
  };

  // On successful update
  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Case Study updated successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.casestudy.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading title="Edit Case Study" subTitle="Update case study details" />
          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6 className="">Edit Case Study Form</h6>

              {/* Name */}
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>

              {/* Live URL */}
              <div className="col-md-4">
                <label className="form-label">Live URL</label>
                <input
                  type="url"
                  className="form-control"
                  value={formData.live_url}
                  onChange={(e) =>
                    setFormData({ ...formData, live_url: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.live_url}
                </span>
              </div>

              {/* Image Upload */}
              <div className="col-md-4">
                <label className="form-label">Image Upload</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="mt-2"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                )}
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
              </div>

              {/* Description */}
              <div className="col-md-12">
                <label className="form-label">Description</label>
                <div className="border rounded bg-white p-2">
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "fontSize",
                        "list",
                        "textAlign",
                        "colorPicker",
                        "link",
                        "embedded",
                        "remove",
                        "history",
                      ],
                    }}
                  />
                </div>
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.description}
                </span>
              </div>

              {/* Submit Button */}
              <div className="col-4 mt-5 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default EditCaseStudy;

